import { Component } from '@angular/core';
import { BaseComponent } from '@components/base/base';
import { NgxPermissionsService } from 'ngx-permissions';
import { isAdmin } from '@utils/helper';
import { PermissionsService } from '@services/permissions.service';

@Component({
  selector: 'app-page-layout',
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent extends BaseComponent {
  isAdmin?: boolean = false;

  constructor(
    private permissionsService: PermissionsService,
  ) {
    super();
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.unSubOnDestroy(this.permissionsService.userInfo).subscribe({
      next: ({ role }) => {
        this.isAdmin = isAdmin(role);
      },
    });
  }
}
